module.exports = __webpack_public_path__ + "static/media/work-icon.de240cfd.png";